import { Text } from "@chakra-ui/react";
import React from "react";

function CommunityGuidelines() {
  return (
    <>
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Violence:</span> You may not
        threaten violence against an individual or a group of people. We also
        prohibit the glorification of violence.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Terrorism/violent extremism:</span>
        You may not threaten or promote terrorism or violent extremism.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Child sexual exploitation:</span>
        We have zero tolerance for child sexual exploitation on Chathouse.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Abuse/harassment:</span> You may
        not engage in the targeted harassment of someone, or incite other people
        to do so. This includes wishing or hoping that someone experiences
        physical harm.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Hateful conduct:</span> You may not
        promote violence against, threaten, or harass other people on the basis
        of race, ethnicity, national origin, caste, sexual orientation, gender,
        gender identity, religious affiliation, age, disability, or serious
        disease.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Suicide or self-harm:</span> You
        may not promote or encourage suicide or self-harm.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>
          Sensitive media, including graphic violence and adult content:
        </span>{" "}
        You may not post media that is excessively gory or share violent or
        adult content at any cost. Media depicting sexual violence and/or
        assault is also not permitted.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>
          Illegal or certain regulated goods or services:
        </span>{" "}
        You may not use our service for any unlawful purpose or in furtherance
        of illegal activities. This includes selling, buying, or facilitating
        transactions in illegal goods or services, as well as certain types of
        regulated goods or services.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Private information:</span> You may
        not publish or post other people's private information (such as home
        phone number and address) without their express authorization and
        permission. We also prohibit threatening to expose private information
        or incentivizing others to do so.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Civic Integrity:</span> You may not
        use our services for the purpose of manipulating or interfering in
        elections or other civic processes. This includes posting or sharing
        content that may suppress participation or mislead people about when,
        where, or how to participate in a civic process.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Impersonation:</span> You may not
        impersonate individuals, groups, or organizations in a manner that is
        intended to or does mislead, confuse, or deceive others.
      </Text>
      <br />
      <Text as="h2">
        <span style={{ fontWeight: "bold" }}>Copyright and trademark:</span> You
        may not violate others’ intellectual property rights, including
        copyright and trademark.
      </Text>
    </>
  );
}

export default CommunityGuidelines;
